export default {
  analytics: {
    header: {
      title: 'Metrics',
      back: 'Back to my pages',
      subtitle: {
        edit: 'Edit',
      },
    },
    info: {
      cacheDelay: '*Page metrics may take up to one day to be refreshed',
    },
  },
  boxes: {
    total: 'Total',
    conversions: {
      title: 'Conversions',
      conversionRate: 'Conversion Rate',
      showEmails: 'View captured emails',
      conversionType: 'Conversion identifier',
      subscriptionIdentifier: 'Registration on email form',
      linkIdentifier: 'Link {identifier}',
    },
    duration: {
      title: 'Average duration',
    },
    visitors: {
      title: 'Visitors',
      unique: 'Unique',
      local: 'Location',
      country: 'Country',
      visits: 'Visits',
      showMap: "View visitors' origin",
    },
  },
  date: {
    simpleFormat: 'MM/dd/yyyy',
    dateAndTime: 'MM/DD/YYYY hh:mm a',
    simpleFormatDash: 'MM-DD-YYYY',
  },
  emailsList: {
    title: 'Captured emails',
    emailColumn: 'Email address',
    dateColumn: 'Date',
    searchPlaceholder: 'Search address',
    capturedEmails: 'No captured emails | 1 email captured |  {count} emails captured',
    export: {
      button: 'Export',
      fileName: 'List of captured emails',
    },
  },
  pagination: {
    previous: 'Previous',
    next: 'Next',
  },
  chart: {
    period: 'Period',
    date: {
      from: 'From',
      to: 'to',
      invalidPeriod: 'The start date of the period must be before the final date. Please select another period of dates. ',
    },
    filter: 'Filter and show chart',
    granularity: {
      hour: {
        label: 'Time',
        format: 'MM/DD [at] HH[h]',
      },
      day: {
        label: 'Day',
        format: 'MM/DD',
      },
    },
    noData: 'No data for the period',
  },
  locations: {
    title: "Visitors' origin",
    searchPlaceholder: 'Filter locale',
    visitors_percent: '% of visitors',
    visitors: 'No visitors | 1 visitor | {count} visitors',
    cities: 'from 1 city | from {count} cities',
    countries: 'in 1 country | in {count} countries',
    not_identified: 'Not identified',
  },
  notifications: {
    noNotifications: 'There are no new notifications.',
    unableLoad: 'We were unable to load notifications at this time.',
  },
  loading: {
    title: 'We are processing the action. Please wait while we load the data.',
    subtitle: 'The request may take a few minutes.',
  },
  error: {
    notFound: {
      title: 'We could not find this page`s metrics',
      buttons: {
        home: 'Go to home page',
      },
    },
    metricsProcess: {
      title: 'Something went wrong',
      subtitle: 'We were unable to load this page right now, but we are working to resolve the issue. Try again in a few minutes. If the problem persists, you can contact our Support.',
      buttons: {
        home: 'Try again',
        support: 'Contact support',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/messages/languages/enUs.js